// import React, { useEffect, useState } from "react";
// import { useAuthState } from "react-firebase-hooks/auth";
// import { Link, useParams, useNavigate } from "react-router-dom";
// import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
// import auth from "../../firebase.init";
// import { Helmet } from "react-helmet";

// const PayNow = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [order, setOrder] = useState(null);
//   const [user] = useAuthState(auth);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [paypalSettings, setPaypalSettings] = useState(null);
//   const [settingsLoading, setSettingsLoading] = useState(true);

//   useEffect(() => {
//     setLoading(true);
//     fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/order/${id}`)
//       .then((res) => res.json())
//       .then((info) => {
//         setOrder(info);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error loading order:", err);
//         setError("Failed to load order details");
//         setLoading(false);
//       });

//     // Fetch PayPal settings
//     fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/paypal-settings`)
//       .then((res) => res.json())
//       .then((response) => {
//         if (response.success) {
//           setPaypalSettings(response.data);
//         } else {
//           console.error("Error in PayPal settings response:", response);
//           setError("Failed to load payment gateway settings");
//         }
//         setSettingsLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error loading PayPal settings:", err);
//         setError("Failed to load payment gateway settings");
//         setSettingsLoading(false);
//       });
//   }, [id]);

//   // Helper function to calculate membership validity date
//   // const calculateMembershipValidity = (createdAt, validityDays) => {
//   //   const createdDate = new Date(createdAt);
//   //   return new Date(
//   //     createdDate.setDate(createdDate.getDate() + parseInt(validityDays))
//   //   ).toISOString();
//   // };

//   const calculateMembershipValidity = (createdAt, validityDays) => {
//     if (!createdAt) {
//       console.error("Invalid createdAt value:", createdAt);
//       return null; // or a default date
//     }

//     const createdDate = new Date(createdAt);
//     if (isNaN(createdDate)) {
//       console.error("Invalid date format:", createdAt);
//       return null;
//     }

//     return new Date(
//       createdDate.setDate(createdDate.getDate() + parseInt(validityDays))
//     ).toISOString();
//   };
//   const createOrder = (data, actions) => {
//     if (!order) {
//       console.error("Order data not available");
//       return;
//     }
//     console.log("Creating PayPal order with amount:", order.totalPrice);
//     return actions.order.create({
//       purchase_units: [
//         {
//           amount: {
//             value: order.totalPrice,
//             breakdown: {
//               item_total: {
//                 currency_code: paypalSettings.currency || "USD",
//                 value: order.packagePrice,
//               },
//               handling: {
//                 currency_code: paypalSettings.currency || "USD",
//                 value: order.processingFee,
//               },
//             },
//           },
//           description: order.packageName,
//           custom_id: order.orderId,
//         },
//       ],
//     });
//   };

//   const onApprove = async (data, actions) => {
//     try {
//       const details = await actions.order.capture();
//       console.log("Payment completed", details);

//       // Calculate membership validity date
//       const membershipValidity = calculateMembershipValidity(
//         order.createdAt,
//         order.Validity
//       );

//       // First update the order status
//       await fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/update-payment-status/${id}`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           paypalTransactionID:
//             details?.purchase_units[0]?.payments?.captures[0]?.id,
//           payerEmail: details.payer?.email_address,
//           captureTime:
//             details?.purchase_units[0]?.payments?.captures[0]?.create_time,
//           paymentId: order.paymentId,
//           orderId: order.orderId,
//           status: "Paid",
//           orderStatus: "Completed",
//           paymentMethod: "Paypal",
//           MembershipValidity: membershipValidity,
//         }),
//       });

//       // Then update the user's membership validity
//       await fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/update-user-membership`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           userEmail: order.customerEmail,
//           MembershipValidity: membershipValidity,
//           userMembership: "premium", // Assuming purchase makes user premium
//         }),
//       });

//       // Update user's currentBalance by adding the package credits
//       if (order.credit) {
//         await fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/update-user-balance`, {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             userEmail: order.customerEmail,
//             credit: order.credit, // Add this amount to user's balance
//           }),
//         });
//       }

//       // Redirect to success page
//       navigate(`/user/subscription-history`);
//     } catch (error) {
//       console.error("Payment failed:", error);
//       setError("Payment failed. Please try again.");
//       navigate(`/user/dashboard`);
//     }
//   };

//   if (loading || settingsLoading) {
//     return (
//       <div className="d-flex flex-column align-items-center justify-content-center min-vh-50 py-5">
//         <div
//           className="spinner-border text-primary"
//           role="status"
//           style={{ width: "3rem", height: "3rem" }}
//         >
//           <span className="visually-hidden">Loading...</span>
//         </div>
//         <p className="mt-3 fw-medium text-primary">
//           Loading payment details...
//         </p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="container py-5">
//         <div className="row justify-content-center">
//           <div className="col-md-8 col-lg-6">
//             <div className="alert alert-danger shadow-sm border-0 rounded-3 p-4">
//               <h4 className="alert-heading mb-3">
//                 <i className="bi bi-exclamation-triangle-fill me-2"></i>Error
//               </h4>
//               <p className="mb-3">{error}</p>
//               <button
//                 className="btn btn-primary px-4 py-2"
//                 onClick={() => navigate("/")}
//               >
//                 Return to Home
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!order || !paypalSettings) {
//     return (
//       <div className="container py-5">
//         <div className="row justify-content-center">
//           <div className="col-md-8 col-lg-6">
//             <div className="alert alert-warning shadow-sm border-0 rounded-3 p-4">
//               <h4 className="alert-heading mb-3">
//                 <i className="bi bi-question-circle-fill me-2"></i>Order Not
//                 Found
//               </h4>
//               <p className="mb-3">
//                 We couldn't find the order you're looking for. Please check the
//                 order ID and try again.
//               </p>
//               <button
//                 className="btn btn-primary px-4 py-2"
//                 onClick={() => navigate("/")}
//               >
//                 Return to Home
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Configure PayPal options based on API response
//   const paypalOptions = {
//     "client-id": paypalSettings.clientId,
//     currency: paypalSettings.currency,
//     intent: "capture",
//     components: "buttons",
//   };

//   // PayPal button styles from API settings
//   const buttonStyles = paypalSettings.buttonStyles || {
//     layout: "vertical",
//     color: "blue",
//     shape: "rect",
//     label: "pay",
//   };

//   // If PayPal is disabled in settings, show an appropriate message
//   if (!paypalSettings.enablePayPal) {
//     return (
//       <div className="d-flex justify-content-center align-items-center min-vh-100">
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-md-8 col-lg-6">
//               <div className="alert alert-info shadow-sm border-0 rounded-3 p-4">
//                 <h4 className="alert-heading mb-3">
//                   <i className="bi bi-info-circle-fill me-2"></i>Payment
//                   Unavailable
//                 </h4>
//                 <p className="mb-3">
//                   PayPal payments are currently unavailable. Please contact
//                   support for alternative payment methods.
//                 </p>
//                 <button
//                   className="btn btn-primary px-4 py-2"
//                   onClick={() => navigate("/")}
//                 >
//                   Return to Home
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Helmet>
//         <title>Pay Now | Complete Your Payment to Access Products</title>
//         <meta
//           name="description"
//           content="Complete your payment to unlock your purchased digital products. Secure payment options for a seamless transaction."
//         />
//       </Helmet>
//       <main>
//         {/* Breadcrumb Section */}
//         <section
//           className="position-relative py-4 py-md-5 bg-primary bg-gradient text-white"
//           style={{
//             background: "linear-gradient(135deg, #4a6bff 0%, #2541b8 100%)",
//             overflow: "hidden",
//             marginTop: "8rem",
//           }}
//         >
//           <div
//             className="position-absolute top-0 end-0 opacity-10"
//             style={{
//               backgroundImage: "url(assets/img/breadcrumb-bg.svg)",
//               backgroundSize: "cover",
//               width: "100%",
//               height: "100%",
//               zIndex: "0",
//             }}
//           ></div>
//           <div className="container position-relative" style={{ zIndex: "1" }}>
//             <div className="row">
//               <div className="col-lg-8">
//                 <h2 className="fw-bold mb-2 display-6">
//                   Complete Your Payment
//                 </h2>
//                 <nav aria-label="breadcrumb">
//                   <ol className="breadcrumb mb-0">
//                     <li className="breadcrumb-item">
//                       <Link to="/" className="text-white text-opacity-75">
//                         Home
//                       </Link>
//                     </li>
//                     <li
//                       className="breadcrumb-item active text-white"
//                       aria-current="page"
//                     >
//                       Payment
//                     </li>
//                   </ol>
//                 </nav>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Payment Details Section */}
//         <section className="py-5 bg-light">
//           <div className="container">
//             <div className="row justify-content-center">
//               <div className="col-lg-10 col-xl-8">
//                 <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
//                   {/* Header */}
//                   <div className="card-header bg-white p-4 border-bottom border-light">
//                     <div className="d-flex justify-content-between align-items-center flex-wrap">
//                       <div>
//                         <h4 className="mb-1 fw-bold">
//                           {order.packageName || "Digital Product"}
//                         </h4>
//                         <p className="text-muted mb-0">
//                           Order ID:{" "}
//                           <span className="fw-medium">{order.orderId}</span>
//                         </p>
//                       </div>
//                       <div className="text-end">
//                         <h3 className="mb-0 fw-bold text-primary">
//                           ${order.totalPrice} USD
//                         </h3>
//                         <span className="badge bg-success rounded-pill px-3 py-2 mt-2">
//                           {(order.paymentStatus || "Pending").toUpperCase()}
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Order Information */}
//                   <div className="card-body p-4">
//                     <div className="row g-4">
//                       {/* Customer Information */}
//                       <div className="col-md-6">
//                         <div className="p-3 bg-light rounded-3 h-100">
//                           <h5 className="mb-3 fw-semibold border-bottom pb-2">
//                             Customer Information
//                           </h5>
//                           <div className="mb-2 d-flex">
//                             <span
//                               className="text-muted me-2"
//                               style={{ width: "100px" }}
//                             >
//                               Name:
//                             </span>
//                             <span className="fw-medium">
//                               {order.customerName}
//                             </span>
//                           </div>
//                           <div className="mb-2 d-flex">
//                             <span
//                               className="text-muted me-2"
//                               style={{ width: "100px" }}
//                             >
//                               Email:
//                             </span>
//                             <span className="fw-medium">
//                               {order.customerEmail}
//                             </span>
//                           </div>
//                           <div className="mb-2 d-flex">
//                             <span
//                               className="text-muted me-2"
//                               style={{ width: "100px" }}
//                             >
//                               Address:
//                             </span>
//                             <span className="fw-medium">
//                               {order.address || "Not specified"}
//                             </span>
//                           </div>
//                           <div className="mb-2 d-flex">
//                             <span
//                               className="text-muted me-2"
//                               style={{ width: "100px" }}
//                             >
//                               Country:
//                             </span>
//                             <span className="fw-medium">
//                               {order.country || "Not specified"}
//                             </span>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Order Details */}
//                       <div className="col-md-6">
//                         <div className="p-3 bg-light rounded-3 h-100">
//                           <h5 className="mb-3 fw-semibold border-bottom pb-2">
//                             Order Details
//                           </h5>
//                           <div className="mb-2 d-flex justify-content-between">
//                             <span className="text-muted">Package Price:</span>
//                             <span className="fw-medium">
//                               ${order.packagePrice} USD
//                             </span>
//                           </div>
//                           {order.credit && (
//                             <div className="mb-2 d-flex justify-content-between">
//                               <span className="text-muted">Credits:</span>
//                               <span className="fw-medium">
//                                 {order.credit} credits
//                               </span>
//                             </div>
//                           )}
//                           <div className="pt-2 mt-2 border-top border-dashed d-flex justify-content-between">
//                             <span className="fw-semibold">Total:</span>
//                             <span className="fw-bold text-primary">
//                               ${order.totalPrice} USD
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Payment Section */}
//                     <div className="mt-4 pt-3 border-top">
//                       <h5 className="fw-bold mb-4 text-center">
//                         Complete Your Payment
//                       </h5>
//                       {error && (
//                         <div className="alert alert-danger mb-4">
//                           <i className="bi bi-exclamation-triangle-fill me-2"></i>
//                           {error}
//                         </div>
//                       )}
//                       <div className="row justify-content-center">
//                         <div className="col-md-8">
//                           <div className="card shadow-sm border-0 mb-4">
//                             <div className="card-body p-4">
//                               <PayPalScriptProvider options={paypalOptions}>
//                                 <PayPalButtons
//                                   createOrder={createOrder}
//                                   onApprove={onApprove}
//                                   style={buttonStyles}
//                                   onError={(err) => {
//                                     console.error("PayPal error:", err);
//                                     setError(
//                                       "There was an error with PayPal. Please try again."
//                                     );
//                                   }}
//                                 />
//                               </PayPalScriptProvider>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Footer */}
//                   <div className="card-footer bg-white p-4 text-center border-top border-light">
//                     <p className="mb-0">
//                       Need help? Contact our{" "}
//                       <Link to="/contact" className="text-decoration-none">
//                         Support Team
//                       </Link>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </main>
//     </>
//   );
// };

// export default PayNow;

import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, useParams, useNavigate } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import auth from "../../firebase.init";
import { Helmet } from "react-helmet";

const PayNow = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [user] = useAuthState(auth);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paypalSettings, setPaypalSettings] = useState(null);
  const [settingsLoading, setSettingsLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/order/${id}`)
      .then((res) => res.json())
      .then((info) => {
        setOrder(info);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading order:", err);
        setError("Failed to load order details");
        setLoading(false);
      });

    // Fetch PayPal settings
    fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/paypal-settings`)
      .then((res) => res.json())
      .then((response) => {
        if (response.success) {
          setPaypalSettings(response.data);
        } else {
          console.error("Error in PayPal settings response:", response);
          setError("Failed to load payment gateway settings");
        }
        setSettingsLoading(false);
      })
      .catch((err) => {
        console.error("Error loading PayPal settings:", err);
        setError("Failed to load payment gateway settings");
        setSettingsLoading(false);
      });
  }, [id]);

  // Helper function to calculate membership validity date
  // const calculateMembershipValidity = (createdAt, validityDays) => {
  //   const createdDate = new Date(createdAt);
  //   return new Date(
  //     createdDate.setDate(createdDate.getDate() + parseInt(validityDays))
  //   ).toISOString();
  // };

  const calculateMembershipValidity = (createdAt, validityDays) => {
    // Fallback to current date if createdAt is missing or invalid
    let createdDate = new Date(createdAt);
    if (!createdAt || isNaN(createdDate)) {
      console.warn(
        "Invalid createdAt value, using current date instead:",
        createdAt
      );
      createdDate = new Date();
    }

    const days = parseInt(validityDays);
    if (isNaN(days) || days <= 0) {
      console.warn("Invalid validityDays, defaulting to 30 days:", validityDays);
      return new Date(createdDate.setDate(createdDate.getDate() + 30)).toISOString();
    }

    return new Date(createdDate.setDate(createdDate.getDate() + days)).toISOString();
  };

  const createOrder = (data, actions) => {
    if (!order) {
      console.error("Order data not available");
      return;
    }
    console.log("Creating PayPal order with amount:", order.totalPrice);
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: order.totalPrice,
            breakdown: {
              item_total: {
                currency_code: paypalSettings.currency || "USD",
                value: order.packagePrice,
              },
              handling: {
                currency_code: paypalSettings.currency || "USD",
                value: order.processingFee,
              },
            },
          },
          description: order.packageName,
          custom_id: order.orderId,
        },
      ],
    });
  };

  // const onApprove = async (data, actions) => {
  //   try {
  //     const details = await actions.order.capture();
  //     console.log("Payment completed", details);

  //     // Calculate membership validity safely
  //     const membershipValidity = calculateMembershipValidity(
  //       order.createdAt,
  //       order.Validity
  //     );

  //     // Update the order status
  //     await fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/update-payment-status/${id}`, {
  //       method: "PUT",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         paypalTransactionID:
  //           details?.purchase_units?.[0]?.payments?.captures?.[0]?.id || "",
  //         payerEmail: details.payer?.email_address || "",
  //         captureTime:
  //           details?.purchase_units?.[0]?.payments?.captures?.[0]?.create_time ||
  //           new Date().toISOString(),
  //         paymentId: order.paymentId || "",
  //         orderId: order.orderId || "",
  //         status: "Paid",
  //         orderStatus: "Completed",
  //         paymentMethod: "Paypal",
  //         MembershipValidity: membershipValidity,
  //       }),
  //     });

  //     // Update user's membership validity
  //     await fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/update-user-membership`, {
  //       method: "PUT",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         userEmail: order.customerEmail,
  //         MembershipValidity: membershipValidity,
  //         userMembership: "premium",
  //       }),
  //     });

  //     // Update user's current balance if credits exist
  //     if (order.credit) {
  //       await fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/update-user-balance`, {
  //         method: "PUT",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           userEmail: order.customerEmail,
  //           credit: order.credit,
  //         }),
  //       });
  //     }

  //     navigate(`/user/subscription-history`);
  //   } catch (error) {
  //     console.error("Payment failed:", error);
  //     setError("Payment failed. Please try again.");
  //     navigate(`/user/dashboard`);
  //   }
  // };

  const onApprove = async (data, actions) => {
    try {
      const details = await actions.order.capture();
      console.log("Payment completed", details);

      // Calculate membership validity safely
      const membershipValidity = calculateMembershipValidity(
        order.createdAt,
        order.Validity
      );

      // Update the order status
      await fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/update-payment-status/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          paypalTransactionID:
            details?.purchase_units?.[0]?.payments?.captures?.[0]?.id || "",
          payerEmail: details.payer?.email_address || "",
          captureTime:
            details?.purchase_units?.[0]?.payments?.captures?.[0]?.create_time ||
            new Date().toISOString(),
          paymentId: order.paymentId || "",
          orderId: order.orderId || "",
          status: "Paid",
          orderStatus: "Completed",
          paymentMethod: "Paypal",
          MembershipValidity: membershipValidity,
        }),
      });

      // Update user's membership validity
      await fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/update-user-membership`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userEmail: order.customerEmail,
          MembershipValidity: membershipValidity,
          userMembership: "premium",
        }),
      });

      // ✅ Safe balance update (prevent double credit)
      if (order.credit) {
        await fetch(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/update-user-balance-safe`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userEmail: order.customerEmail,
            credit: order.credit,
            orderId: order.orderId, // important for duplicate prevention
          }),
        });
      }

      navigate(`/user/subscription-history`);
    } catch (error) {
      console.error("Payment failed:", error);
      setError("Payment failed. Please try again.");
      navigate(`/user/dashboard`);
    }
  };



  if (loading || settingsLoading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center min-vh-50 py-5">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 fw-medium text-primary">
          Loading payment details...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="alert alert-danger shadow-sm border-0 rounded-3 p-4">
              <h4 className="alert-heading mb-3">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>Error
              </h4>
              <p className="mb-3">{error}</p>
              <button
                className="btn btn-primary px-4 py-2"
                onClick={() => navigate("/")}
              >
                Return to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!order || !paypalSettings) {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="alert alert-warning shadow-sm border-0 rounded-3 p-4">
              <h4 className="alert-heading mb-3">
                <i className="bi bi-question-circle-fill me-2"></i>Order Not
                Found
              </h4>
              <p className="mb-3">
                We couldn't find the order you're looking for. Please check the
                order ID and try again.
              </p>
              <button
                className="btn btn-primary px-4 py-2"
                onClick={() => navigate("/")}
              >
                Return to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Configure PayPal options based on API response
  const paypalOptions = {
    "client-id": paypalSettings.clientId,
    currency: paypalSettings.currency,
    intent: "capture",
    components: "buttons",
  };

  // PayPal button styles from API settings
  const buttonStyles = paypalSettings.buttonStyles || {
    layout: "vertical",
    color: "blue",
    shape: "rect",
    label: "pay",
  };

  // If PayPal is disabled in settings, show an appropriate message
  if (!paypalSettings.enablePayPal) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="alert alert-info shadow-sm border-0 rounded-3 p-4">
                <h4 className="alert-heading mb-3">
                  <i className="bi bi-info-circle-fill me-2"></i>Payment
                  Unavailable
                </h4>
                <p className="mb-3">
                  PayPal payments are currently unavailable. Please contact
                  support for alternative payment methods.
                </p>
                <button
                  className="btn btn-primary px-4 py-2"
                  onClick={() => navigate("/")}
                >
                  Return to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Pay Now | Complete Your Payment to Access Products</title>
        <meta
          name="description"
          content="Complete your payment to unlock your purchased digital products. Secure payment options for a seamless transaction."
        />
      </Helmet>
      <main>
        {/* Breadcrumb Section */}
        <section
          className="position-relative py-4 py-md-5 bg-primary bg-gradient text-white"
          style={{
            background: "linear-gradient(135deg, #4a6bff 0%, #2541b8 100%)",
            overflow: "hidden",
            marginTop: "8rem",
          }}
        >
          <div
            className="position-absolute top-0 end-0 opacity-10"
            style={{
              backgroundImage: "url(assets/img/breadcrumb-bg.svg)",
              backgroundSize: "cover",
              width: "100%",
              height: "100%",
              zIndex: "0",
            }}
          ></div>
          <div className="container position-relative" style={{ zIndex: "1" }}>
            <div className="row">
              <div className="col-lg-8">
                <h2 className="fw-bold mb-2 display-6">
                  Complete Your Payment
                </h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/" className="text-white text-opacity-75">
                        Home
                      </Link>
                    </li>
                    <li
                      className="breadcrumb-item active text-white"
                      aria-current="page"
                    >
                      Payment
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>

        {/* Payment Details Section */}
        <section className="py-5 bg-light">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10 col-xl-8">
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                  {/* Header */}
                  <div className="card-header bg-white p-4 border-bottom border-light">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                      <div>
                        <h4 className="mb-1 fw-bold">
                          {order.packageName || "Digital Product"}
                        </h4>
                        <p className="text-muted mb-0">
                          Order ID:{" "}
                          <span className="fw-medium">{order.orderId}</span>
                        </p>
                      </div>
                      <div className="text-end">
                        <h3 className="mb-0 fw-bold text-primary">
                          ${order.totalPrice} USD
                        </h3>
                        <span className="badge bg-success rounded-pill px-3 py-2 mt-2">
                          {(order.paymentStatus || "Pending").toUpperCase()}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Order Information */}
                  <div className="card-body p-4">
                    <div className="row g-4">
                      {/* Customer Information */}
                      <div className="col-md-6">
                        <div className="p-3 bg-light rounded-3 h-100">
                          <h5 className="mb-3 fw-semibold border-bottom pb-2">
                            Customer Information
                          </h5>
                          <div className="mb-2 d-flex">
                            <span
                              className="text-muted me-2"
                              style={{ width: "100px" }}
                            >
                              Name:
                            </span>
                            <span className="fw-medium">
                              {order.customerName}
                            </span>
                          </div>
                          <div className="mb-2 d-flex">
                            <span
                              className="text-muted me-2"
                              style={{ width: "100px" }}
                            >
                              Email:
                            </span>
                            <span className="fw-medium">
                              {order.customerEmail}
                            </span>
                          </div>
                          <div className="mb-2 d-flex">
                            <span
                              className="text-muted me-2"
                              style={{ width: "100px" }}
                            >
                              Address:
                            </span>
                            <span className="fw-medium">
                              {order.address || "Not specified"}
                            </span>
                          </div>
                          <div className="mb-2 d-flex">
                            <span
                              className="text-muted me-2"
                              style={{ width: "100px" }}
                            >
                              Country:
                            </span>
                            <span className="fw-medium">
                              {order.country || "Not specified"}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Order Details */}
                      <div className="col-md-6">
                        <div className="p-3 bg-light rounded-3 h-100">
                          <h5 className="mb-3 fw-semibold border-bottom pb-2">
                            Order Details
                          </h5>
                          <div className="mb-2 d-flex justify-content-between">
                            <span className="text-muted">Package Price:</span>
                            <span className="fw-medium">
                              ${order.packagePrice} USD
                            </span>
                          </div>
                          {order.credit && (
                            <div className="mb-2 d-flex justify-content-between">
                              <span className="text-muted">Credits:</span>
                              <span className="fw-medium">
                                {order.credit} credits
                              </span>
                            </div>
                          )}
                          <div className="pt-2 mt-2 border-top border-dashed d-flex justify-content-between">
                            <span className="fw-semibold">Total:</span>
                            <span className="fw-bold text-primary">
                              ${order.totalPrice} USD
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Payment Section */}
                    <div className="mt-4 pt-3 border-top">
                      <h5 className="fw-bold mb-4 text-center">
                        Complete Your Payment
                      </h5>
                      {error && (
                        <div className="alert alert-danger mb-4">
                          <i className="bi bi-exclamation-triangle-fill me-2"></i>
                          {error}
                        </div>
                      )}
                      <div className="row justify-content-center">
                        <div className="col-md-8">
                          <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body p-4">
                              <PayPalScriptProvider options={paypalOptions}>
                                <PayPalButtons
                                  createOrder={createOrder}
                                  onApprove={onApprove}
                                  style={buttonStyles}
                                  onError={(err) => {
                                    console.error("PayPal error:", err);
                                    setError(
                                      "There was an error with PayPal. Please try again."
                                    );
                                  }}
                                />
                              </PayPalScriptProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="card-footer bg-white p-4 text-center border-top border-light">
                    <p className="mb-0">
                      Need help? Contact our{" "}
                      <Link to="/contact" className="text-decoration-none">
                        Support Team
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default PayNow;